import { SIDEBAR_BOTTOM_CONTENT_ID } from 'client/constants/editorIds'
import React from 'react'
import ReactDOM from 'react-dom'

interface SidebarBottomPortalProps {
  className?: string
  children: React.ReactNode
}

export const SidebarBottomPortal = ({
  className,
  children,
}: SidebarBottomPortalProps) => {
  return ReactDOM.createPortal(
    <div className={className}>{children}</div>,
    document.getElementById(SIDEBAR_BOTTOM_CONTENT_ID) as HTMLElement,
  )
}
